<div [class.form-control-icon]="classIcon" [class.clearable]="clean">
  <ng-content></ng-content>
  <i *ngIf="classIcon" [class]="classIcon" class="icon-append" (click)="onFocus()"></i>
</div>

<div *ngIf="invalid && showMessage" class="d-flex text-danger mt-2">
  <i class="fas fa-exclamation-circle me-1"></i>
  <small *ngFor="let error of errors" class="lh-sm">{{ error }}</small>
</div>
